export const GlobalThemeType = {
    light: "light",
    dark: "dark",
    systemDark: "systemDark",
    systemLight: "systemLight",
};

export const GlobalThemeClass = {
    light: "light",
    dark: "dark",
};

const THEME_KEY = "uxuyTheme";
const DEFALUT_THEME = GlobalThemeType.systemLight;

// https://github.com/sandoche/Darkmode.js
export const getThemeLightEvent = function () {
    return typeof window != "undefined"
        ? window.matchMedia("(prefers-color-scheme: light)")
        : null;
};

export const getThemeDarkEvent = function () {
    return typeof window != "undefined"
        ? window.matchMedia("(prefers-color-scheme: dark)")
        : null;
};

export const isSystemTheme = function (type) {
    return [GlobalThemeType.systemDark, GlobalThemeType.systemLight].includes(
        type
    );
};

// export const isCustomTheme = function (type: GlobalThemeType) {
//   return [GlobalThemeType.dark, GlobalThemeType.light].includes(type)
// }

export const isDarkTheme = function (type) {
    return [GlobalThemeType.systemDark, GlobalThemeType.dark].includes(type);
};

export const isAllowTheme = function (theme) {
    const themeType = Object.values(GlobalThemeType).find((v) => theme == v);
    if (!themeType) console.warn("no found:", themeType);
    return themeType;
};

export const getThemeClass = function (theme) {
    return [GlobalThemeType.dark, GlobalThemeType.systemDark].includes(theme)
        ? GlobalThemeClass.dark
        : GlobalThemeClass.light;
};

export const getTheme = function () {
    let theme = sessionStorage.getItem(THEME_KEY);
    const themeDarkEvent = getThemeDarkEvent();
    let default_theme = themeDarkEvent?.matches
        ? GlobalThemeType.systemDark
        : DEFALUT_THEME;

    if (!theme) return default_theme;
    let isTrue = isAllowTheme(theme);
    return isTrue ? theme : default_theme;
};

export const setTheme = function (value = GlobalThemeType.systemDark) {
    sessionStorage.getItem(THEME_KEY) != value && sessionStorage.setItem(THEME_KEY, value);

    if ([GlobalThemeType.light, GlobalThemeType.systemLight].includes(value)) {
        document.documentElement.classList.contains(GlobalThemeClass.dark) &&
            document.documentElement.classList.remove(GlobalThemeClass.dark);
        !document.documentElement.classList.contains(GlobalThemeClass.light) &&
            document.documentElement.classList.add(GlobalThemeClass.light);
    } else {
        document.documentElement.classList.contains(GlobalThemeClass.light) &&
            document.documentElement.classList.remove(GlobalThemeClass.light);
        !document.documentElement.classList.contains(GlobalThemeClass.dark) &&
            document.documentElement.classList.add(GlobalThemeClass.dark);
    }
    return value;
};
